import React, { createContext, useCallback, useContext, useMemo } from 'react';
import { loadingStore } from './loadingStore';

const LoadingContext = createContext(null);

export function LoadingProvider({ children }) {
  const begin = useCallback(() => loadingStore.begin(), []);
  const end = useCallback(() => loadingStore.end(), []);
  const wrap = useCallback(
    async (promiseLike) => {
      begin();
      try {
        return await promiseLike;
      } finally {
        end();
      }
    },
    [begin, end]
  );

  const value = useMemo(() => ({ begin, end, wrap }), [begin, end, wrap]);
  return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>;
}

export function useLoadingActions() {
  const ctx = useContext(LoadingContext);
  if (!ctx) {
    throw new Error('useLoadingActions must be used within <LoadingProvider>.');
  }
  return ctx;
}

